import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// Import des fichiers de traduction
import translationDE from './i18n/locales/de/translation.json';


const resources = {
    de: {
        translation: translationDE
    }
};

i18n
    // Charge les traductions depuis le serveur
    .use(Backend)
    // Détecte la langue (désactivé, car nous utilisons uniquement l'allemand)
    // .use(I18nextBrowserLanguageDetector)
    // Passe l'instance i18n à react-i18next
    .use(initReactI18next)
    // Configuration d'i18n
    .init({
        resources,
        lng: 'de', // Langue par défaut: Allemand
        fallbackLng: 'de', // Langue de secours si une clé n'est pas trouvée

        // Non nécessaire pour React car il échappe par défaut
        interpolation: {
            escapeValue: false,
        },

        // Options pour ne pas permettre de changer de langue
        detection: {
            // Vide pour désactiver la détection de langue
            order: [],
        },

        react: {
            useSuspense: true,
        },
    });

export default i18n; 